var path = '/templates/projects.segments/campaign_segment_show_inactive.html';
var html = "<h4>{{ 'projectsSegments.campaignSegmentShowInactive.kihonjouken' | translate }}</h4><table class=\"table table-bordered segment-detail-table\"><tr><th><zc-campaign-segment-flag segment=segment short=true></zc-campaign-segment-flag></th><td ng-show=project.installed_at>{{ 'projectsSegments.campaignSegmentShowInactive' | translate: { dayssincelastconversion: segment.conditions_json.days_since_last_conversion } }}</td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.segments/campaign_segment_show_inactive.html
// module id = 1446
// module chunks = 0